import { EInvoiceViewer } from './einvoice-viewer'
import type { ReactNode } from 'react'
import type { EInvoice } from '@/lib/api/einvoice-api'
import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

/** Statuses whose answer may already be on MISA: asking again can turn them
 *  into an issued invoice. */
const CHECKABLE: readonly EInvoice['status'][] = [
    'pushed',
    'rejected',
    'publish_duplicated',
    'publish_unknown',
]
/** Statuses whose primary button is not the draft preview, so the preview is
 *  offered as a quiet link instead. */
const PREVIEWABLE: readonly EInvoice['status'][] = [
    'failed',
    'publish_duplicated',
    'publish_unknown',
]

interface Props {
    orderId: string
    status: EInvoice['status']
    orderCode?: string
    orderStatus?: string
    isQuickSale?: boolean
    /** Asking MISA uses the person's own MISA account. */
    canCheck: boolean
    checking: boolean
    onCheck: () => void
    /** One more small link in the same row, e.g. deleting the draft MISA holds. */
    extra?: ReactNode
}

/** Small text links under the buttons: "Kiểm tra lại với MISA" and "Xem nháp". */
export function EInvoicePendingLinks(props: Props) {
    const check = CHECKABLE.includes(props.status) && props.canCheck
    const preview = PREVIEWABLE.includes(props.status)
    if (!check && !preview && !props.extra) return null
    return (
        <div className="flex flex-wrap gap-x-4 gap-y-1">
            {check ? (
                <Button
                    type="button"
                    variant="link"
                    size="sm"
                    className="h-auto p-0 text-xs"
                    disabled={props.checking}
                    onClick={props.onCheck}
                >
                    {m.einvoice_pending_check()}
                </Button>
            ) : null}
            {preview ? (
                <EInvoiceViewer
                    orderId={props.orderId}
                    status={props.status}
                    orderCode={props.orderCode}
                    orderStatus={props.orderStatus}
                    isQuickSale={props.isQuickSale}
                    triggerLabel={m.einvoice_preview()}
                    triggerLink
                />
            ) : null}
            {props.extra}
        </div>
    )
}
